class ProductPersonalization extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    /* attach early */
    this.form = this.closest('form')
    this.form.querySelector('[data-bundle-key]').value = (new Date).getTime();

    // Attach dialog Early
    this.dialogTmpl = this.querySelector('.mpp-dialog-tmpl')
    this.dialog = document.createElement('div')
    this.dialog.classList.add('mpp-dialog', 'grid__item')
    this.dialog.innerHTML = this.dialogTmpl.innerHTML

    this.targetDiv = this.closest('.grid.product-single')
    this.targetDiv.append(this.dialog)
    this.targetDiv.classList.add('mpp-mounted')

    this.cta = this.querySelector('.mpp-cta')
    this.clearBtn = this.querySelector('.mpp-clear')
    this.dialogCloseBtn = this.dialog.querySelector('.mpp-dialog-close')

    // Variants
    this.imageUrls = this.dataset.imageUrls.split(',')
    this.variantIds = this.dataset.variantIds.split(',')
    this.variantTitles = this.dataset.variantTitles.split(',')

    // Step 0: Emboss: Yes/No
    this.inputEmbossment = this.querySelector('[data-input-embossment]')

    // Step 1(optional): Emboss style (i.e. emboss/prints)
    this.hasStyle = JSON.parse(this.dataset.hasPrint)  // note
    if (this.hasStyle) {
      this.radioStyles = Array.from(this.dialog.querySelectorAll(['[name=mpp-style]']))
      this.inputStyle = this.querySelector('[data-input-style]')
    }

    // Step 2: Initials
    this.fieldInitials = this.dialog.querySelector('[data-field-initials]')
    this.inputInitials = this.querySelector('[data-input-initials]')
    this.maxlength = JSON.parse(this.dataset.maxlength)
    if (this.dataset.addonVariantId) {
      this.hasAddon = true
      this.addonMaxlength = JSON.parse(this.dataset.addonMaxlength)
      this.addonVariantId = JSON.parse(this.dataset.addonVariantId)
      this.addonHint = this.dialog.querySelector('[data-addon-hint]')
      this.fieldInitialsError = this.dialog.querySelector('[data-field-initials-error]')
    } else {
      this.hasAddon = false
    }

    // Step 3: Colour (note: spelling)
    this.fieldColour = this.dialog.querySelector('[data-field-colour]')
    this.inputColour = this.querySelector('[data-input-colour]')
    this.indentOption = this.dialog.querySelector('[data-indent-option]')
    
    // Step 4(optional): Size
    this.fieldSize = this.dialog.querySelector('[data-field-size]')
    this.hasSize = !!this.fieldSize
    if (this.hasSize) {
      this.inputSize = this.querySelector('[data-input-size]')
      this.sizes = ['large', 'small']
    }

    // Step 5: Message
    this.inputMessage = this.querySelector('[data-input-message]')
    this.fieldMessage = this.dialog.querySelector('[data-field-message]')

    // Previews
    this.emboss = this.dialog.querySelector('#mpp-emboss-text')
    this.embossSizeUse = this.dialog.querySelector('#mpp-emboss-size-use')
    this.embossUse = this.dialog.querySelector('#mpp-emboss-use')
    this.image = this.dialog.querySelector('.mpp-preview image')
    
    /* Styles */
    this.default = {
      // colour: 'gold',
      colour: this.fieldColour.options[0].value,
      initials: this.emboss.dataset.default,
      size: 'large',
      message: '',
    }
    this.defaultInitials = this.emboss.dataset.default

    /* Steps */
    this.steps = []
    if (this.hasStyle) {
      this.steps.push('style')
    }
    this.steps.push('initials')
    this.steps.push('colour')
    if (this.hasSize) {
      this.steps.push('size') 
    }
    this.steps.push('message')

    /* Validation rules */
    /** TODO: get different validation rules for different product ??? how?? **/
    this.rules = []

    /** TODO: add to input fields **/
    this.initDialogEvents()
    this.initPageEvents()
    this.initFormEvents()

    /* State init */
    this.restoreDefault()
    
    /* Finish */
    this.classList.remove('no-js')
  }

  initDialogEvents() {
    this.cta.addEventListener('click', () => {
      this.openDialog()
    })
    this.dialogCloseBtn.addEventListener('click', () => {
      this.closeDialog()
    })
    this.clearBtn.addEventListener('click', () => {
      this.restoreDefault()
    })
  }
  
  initPageEvents() {
    this.dialog.querySelectorAll('.mpp-page-back').forEach(el => {
      el.addEventListener('click', e => {
        this.gotoStep(this.backStep())
      })
    })
    this.dialog.querySelectorAll('.mpp-page-next').forEach(el => {
      el.addEventListener('click', e => {
        if (!this.stepValid()) {
          return false
        }
        this.gotoStep(this.nextStep())
        this.stepValid()
      })
    })
    this.dialog.querySelectorAll('.mpp-next').forEach(el => {
      el.addEventListener('click', e => {
        if (!this.stepValid()) {
          return false
        }
        this.gotoStep(this.nextStep())
        this.stepValid()
      })
    })
    this.dialog.querySelector('.mpp-save').addEventListener('click', e => {
      this.saveForm()
    })
  }

  initFormEvents() {
    if (this.hasStyle) {
      this.radioStyles.forEach(el => {
        el.addEventListener('input', () => {
          this.updateEmboss({
            style: this.radioStyles.find(el => el.checked).value
          })
        })
      })
    }
    
    this.fieldInitials.addEventListener('input', () => {
      this.fieldInitials.value = this.formatInitials(this.fieldInitials.value)
      this.updateEmboss({
        initials: this.fieldInitials.value
      })
    })

    if (this.hasSize) {
      this.fieldSize.addEventListener('input', () => {
        this.updateEmboss({
          size: this.fieldSize.value
        })
      })
    }
    
    this.fieldColour.addEventListener('input', () => {
      this.updateEmboss({
        'colour': this.fieldColour.value
      })
    })
    
    // this.form.querySelector('#AddToCart-product').addEventListener('click', (e) => {
    //   if (this.saved) {
    //     e.preventDefault()
    //     this.addToCart()
    //   }
    // })
  }

  restoreDefault() {
    this.inputEmbossment.value = 'No'
    this.inputColour.value = ''
    this.inputInitials.value = ''
    if (this.hasSize) this.inputSize.value = ''
    this.inputMessage.value = ''
    
    this.fieldColour.value = this.default.colour
    this.fieldInitials.value = this.default.initials
    if (this.hasSize) this.fieldSize.value = this.default.size
    this.fieldMessage.value = this.default.message

    this.updateEmboss(this.default)
    
    this.gotoStep(this.steps[0])
    this.saved = false

    this.refreshCta()
  }
  
  resetDialog() {
    if (this.saved) {
      this.fieldInitials.value = this.inputInitials.value
      this.fieldColour.value = this.inputColour.value
      if (this.hasSize) this.fieldSize.value = this.inputSize.value
      this.fieldMessage.value = this.inputMessage.value
      
    } else {
      this.step = this.steps[0]
      this.restoreDefault()
    }
  }

  resetImage() {
    this.imageUrls = this.dataset.imageUrls.split(',')
    this.variantIds = this.dataset.variantIds.split(',')
    const index = this.variantIds.indexOf(this.variantId)
    if (index < this.imageUrls.length && index >= 0) {
      this.image.setAttribute('href', this.imageUrls[index])
    } else {
      this.image.setAttribute('href', this.imageUrls[0])
    }
  }

  openDialog() {
    this.variantId = this.form.querySelector('[name=id]').value

    if (this.variantIds.length > 1) {
      const index = this.variantIds.indexOf(this.variantId)
      const variantTitle = this.variantTitles[index].toLowerCase()

      this.default.colour = variantTitle

      this.fieldColour.querySelectorAll('option').forEach(option => {
        if (option.value === variantTitle) {
          option.removeAttribute('hidden')
        } else {
          option.setAttribute('hidden', 'hidden')
        }
      })
      console.log(variantTitle)
    }
    
    this.resetImage()
    this.resetDialog()
    
    this.dialog.classList.add('mpp-dialog-open')
  }

  closeDialog() {
    this.dialog.classList.remove('mpp-dialog-open')
    
    if (!this.saved) {
      this.step = this.steps[0]
      this.clearForm()
      this.restoreDefault()
    }
  }
  
  backStep() {
    return this.steps[this.steps.indexOf(this.step) - 1]
  }
  
  nextStep() {
    return this.steps[this.steps.indexOf(this.step) + 1]
  }
  
  gotoStep(step) {
    this.step = step
    this.dialog.querySelectorAll(`.mpp-step`).forEach(el => {
      if (el.dataset.step === step) el.classList.remove('visually-hidden')
      else el.classList.add('visually-hidden')
    })
  }

  clearForm() {
    this.refreshCta()
    this.restoreDefault()
  }
  
  saveForm() {
    this.inputEmbossment.value = 'Yes'
    if (this.hasStyle) this.inputStyle.value = this.radioStyles.find(el => el.checked).value
    this.inputInitials.value = this.fieldInitials.value
    this.inputColour.value = this.fieldColour.value
    if (this.hasSize) this.inputSize.value = this.fieldSize.value
    this.inputMessage.value = this.fieldMessage.value

    this.saved = true
    this.refreshCta()
    this.closeDialog()
  }

  formatInitials(s) {
    return Array.from(s.toUpperCase())
      .filter(c => c.match(/[A-Z\.\-\'\#\@ ]/g))
      .join('')
  }

  refreshCta() {
    if (this.saved) {
      this.cta.querySelector('span[data-open]').classList.add('visually-hidden')
      this.cta.querySelector('span[data-saved]').classList.remove('visually-hidden')
      this.clearBtn.classList.remove('visually-hidden')
    } else {
      this.cta.querySelector('span[data-open]').classList.remove('visually-hidden')
      this.cta.querySelector('span[data-saved]').classList.add('visually-hidden')
      this.clearBtn.classList.add('visually-hidden')
    }
  }
  
  updateEmboss(options) {
    if ('style' in options) {
      this.emboss.setAttribute('font-family', this.fontStyles[options.style])

      if (options.style === 'Emboss') {
        this.fieldInitials.setAttribute('maxlength', this.fieldInitials.dataset.maxlength)
        this.addonHint.classList.add('visually-hidden')
        // this.indentOption.classList.remove('hidden')
      } else {
        this.fieldInitials.setAttribute('maxlength', this.fieldInitials.dataset.addonMaxlength)
        this.addonHint.classList.remove('visually-hidden')
        // this.indentOption.classList.add('hidden')
      }
    }
    
    if ('colour' in options) {
      const value = options.colour
      
      this.emboss.setAttribute('fill', `url(#mpp-pattern-${value})`)
      this.embossUse.setAttribute('href', `#mpp-use-colour`)

      // if (value === 'indent') {
      //   this.emboss.setAttribute('fill', '')
      //   this.embossUse.setAttribute('href', `#mpp-use-indent`)
      // } else {
      //   this.emboss.setAttribute('fill', `url(#mpp-pattern-${value})`)
      //   this.embossUse.setAttribute('href', `#mpp-use-colour`)
      // }
    }

    if ('initials' in options) {
      const value = options.initials
      if (this.validInitials(value)) {
        this.emboss.innerHTML = value
      }
    }

    if ('size' in options && this.hasSize) {
      const value = options.size
      if (value === 'large') {
        this.emboss.setAttribute('font-size', this.emboss.dataset.largeFontSize)
      } else if (value === 'small') {
        this.emboss.setAttribute('font-size', this.emboss.dataset.smallFontSize)
      }
    }
  }

  stepValid() {
    if (this.step === 'initials') {
      if (this.hasStyle && this.hasAddon) {
        const style = this.radioStyles.find(el => el.checked).value
        if (style === 'Emboss' && this.fieldInitials.value.length > this.maxlength) {
          this.fieldInitials.classList.add('error')
          this.fieldInitialsError.classList.remove('visually-hidden')
          return false
        } else {
          this.fieldInitials.classList.remove('error')
          this.fieldInitialsError.classList.add('visually-hidden')
        }
      }
    }
    return true
  }

  validInitials(text) {
    // TODO: validate
    return true
  }

  addToCart() {
    const qty = JSON.parse(this.form.querySelector('.QuantityInput').value)
    if (qty < 1) {
      return
    }

    const key = (new Date).getTime();
    const items = [
      {
        'id': this.variantId,
        'quantity': qty,
        'properties': {
          'Embossment': 'Yes',
          'Initials': this.inputInitials.value,
          ...(this.hasStyle ? { 'Style': this.inputStyle.value } : {}),
          ...(this.hasSize ? { 'Size': this.inputSize.value } : {}),
          'Colour': this.inputColour.value,
          'Message': this.inputMessage.value,
          '_bundle-key-main': key,
        }
      }
    ]
    
    if (this.inputInitials.value.length > this.maxlength) {
      if (this.hasAddon) {
        items.push({
          'id': this.addonVariantId,
          'quantity': qty,
          'properties': {
            '_bundle-key-addon': key,
          }
        })
      } else {
        // TODO: error
      }
    }
    
    const data = {
      'items': items
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    })
      .then(resp => resp.json())
      .then(resp => {
        // TODO: errors?
        window.location = window.Shopify.routes.root + 'cart'
      })
  }
}

customElements.define("product-personalization", ProductPersonalization)
